namespace $ {

	export type $shm_hitalama_mcp_context_data = {
		session_id: string
		client_id: string
		map_id: string
		map_title: string
		url: string
	}

	export class $shm_hitalama_mcp_context extends $mol_object2 {

		static http_url( source: string ) {
			const url = new URL( source, $mol_dom_context.document?.location.href )
			if( url.protocol === 'ws:' ) url.protocol = 'http:'
			if( url.protocol === 'wss:' ) url.protocol = 'https:'
			url.pathname = url.pathname.replace( /\/(?:hitalama-mcp|mcp)\/?$/, '' )
			url.search = ''
			url.hash = ''
			return url.toString().replace( /\/$/, '' )
		}

		static async register(
			base: string,
			token: string,
			session_id: string,
			client_id: string,
			map_id: string,
			map_title: string,
			url: string,
		) {
			const response = await fetch( `${ this.http_url( base ) }/session/context`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					...( token.trim() ? { 'X-Hitalama-Agent-Token': token.trim() } : {} ),
				},
				body: JSON.stringify({ session_id, client_id, map_id, map_title, url }),
			} )
			if( !response.ok ) throw new Error( `Hitalama MCP context: HTTP ${ response.status }` )
			return response.json() as Promise< { ok: boolean, context: $shm_hitalama_mcp_context_data } >
		}

	}

}
